import { memo, useMemo } from "react"
import { colors } from "design/colors"
import { belowViewPort } from "utils"

export const buttonVariablesLight = {
  "--resbird-button-secondary-border-color": colors.primaryBlueGrey,
  "--resbird-button-primary-background": colors.lightBlueGrey,
  "--resbird-button-secondary-background": colors.lightBlueGrey,
  "--resbird-button-secondary-color": colors.primaryBlueGrey,
  "--resbird-button-primary-color": colors.grey800,
}

const computeButtonStyle = ({ secondary, disabled }) => ({
  borderRadius: 6,
  boxSizing: "border-box",
  minWidth: 150,
  height: 45,
  paddingLeft: 30,
  paddingRight: 30,
  fontSize: "1rem",
  fontWeight: 500,
  textTransform: "uppercase",
  textWrap: "nowrap",
  color: secondary
    ? "var(--resbird-button-secondary-color)"
    : "var(--resbird-button-primary-color)",
  border: `1px solid ${secondary ? "var(--resbird-button-secondary-border-color)" : "transparent"}`,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.6 : 1,
  background: secondary
    ? "var(--resbird-button-secondary-background)"
    : "var(--resbird-button-primary-background)",
  ":hover:not(:disabled)": {
    opacity: 0.97,
  },
  ":active:not(:disabled)": {
    opacity: 1,
  },
  ...belowViewPort(1441, { fontSize: "0.75rem" })
})

export const Button = memo(
  ({
    className,
    type = "button",
    title,
    children,
    disabled,
    secondary,
    onClick,
    ...props
  }) => {
    const buttonStyle = useMemo(
      () => computeButtonStyle({ secondary, disabled }),
      [disabled, secondary],
    )

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        // eslint-disable-next-line react/button-has-type
        type={type}
        className={className}
        css={buttonStyle}
        onClick={disabled ? null : onClick}
        {...props}
        disabled={disabled}
      >
        {title}
        {children}
      </button>
    )
  },
)

Button.displayName = "Button"
